const isObjectEmpty = (o: object | undefined) => {
  return o && Object.keys(o).length === 0 && o.constructor === Object;
};

export default isObjectEmpty;
